// extracted by mini-css-extract-plugin
export default {"catalog__products":"CatalogItemsList_catalog__products__vCCiY","catalog__empty":"CatalogItemsList_catalog__empty__SxG4+"};